import React from 'react';
import { connect } from 'react-redux';
import FeedPage from 'src/components/FeedPage/FeedPage';
import { setLocale, setWhoAmI } from 'src/lib/redux/modules/settings';
import { wrapper } from 'src/lib/redux/store';
import { resolveHost } from 'src/lib/whoami';

export const getServerSideProps = wrapper.getServerSideProps(store => context => {
	const { req, locale } = context;
	const host = req.headers.host;
	const whoami = resolveHost(host);
	store.dispatch(setLocale({ locale }));
	store.dispatch(setWhoAmI({ whoami }));
	return {
		props: { host }, // will be passed to the page component as props
	};
});

const Search = props => {
	const { host } = props;
	return <FeedPage host={host} />;
};

Search.propTypes = {};

Search.defaultProps = {};

export default connect((state) => state)(Search);
